import { useEffect, useState } from "react";
import axios from "../puglins/Utils/axios";

// 🔌 Fonctionnalités en préparation (planning…) : état lu une fois par page chargée
// (GET /api/features), coupé tant que l'API ne dit pas le contraire ou ne répond pas
let pending = null;
// État déjà lu : un composant monté ensuite (page suivante) l'a dès son premier affichage, sans
// passer par « inconnu » (évite de voir l'ancien en-tête une fraction de seconde)
let known = null;
// 🥇 Dernier jour de la garantie du premier cours, reçu avec les fonctionnalités (tour 47, helper/guaranteeDate.js)
let lastDay = null;

export const loadFeatures = () => {
  if (!pending)
    pending = axios
      .get("/features")
      .then(({ data }) => {
        lastDay = data?.guarantee_last_day || null;
        return (known = data?.features || {});
      })
      .catch(() => {
        pending = null; // réessayé à la prochaine page
        return {};
      });
  return pending;
};

// null tant que l'état n'est pas connu, puis true ou false
export const useFeature = (key) => {
  const [enabled, setEnabled] = useState(() => (known ? !!known[key] : null));
  useEffect(() => {
    let alive = true;
    loadFeatures().then((features) => alive && setEnabled(!!features[key]));
    return () => {
      alive = false;
    };
  }, [key]);
  return enabled;
};

export const guaranteeLastDay = () => lastDay;

export const resetFeaturesForTests = () => {
  pending = null;
  known = null;
  lastDay = null;
};
